import { render, staticRenderFns } from "./CreateNewForm.vue?vue&type=template&id=61090e6f&"
import script from "./CreateNewForm.vue?vue&type=script&lang=js&"
export * from "./CreateNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports